import { showLoadingOverlay, closeLoadingOverlay } from '@/utils/toast'

// 显示

// 关闭
closeLoadingOverlay()
export function useWebViewResumeReload() {
    // 进入后台时间
    let hiddenTime = 0

    // 超过多久 reload
    const RELOAD_DURATION = 1000 * 60 * 5

    const handleVisibilityChange = () => {
        // 进入后台
        if (document.visibilityState === 'hidden') {
            hiddenTime = Date.now()
        }

        // 回到前台
        if (document.visibilityState === 'visible') {
            const now = Date.now()

            const stayBackgroundTime =
                now - hiddenTime



            // 超过5分钟 reload
            if (
                hiddenTime &&
                stayBackgroundTime > RELOAD_DURATION
            ) {
                console.log(
                    '后台停留时间:',
                    stayBackgroundTime
                )
                showLoadingOverlay('Please wait...')
                window.location.reload()
            }
        }
    }

    // 注册监听
    document.addEventListener(
        'visibilitychange',
        handleVisibilityChange
    )

    // 卸载
    return () => {
        document.removeEventListener(
            'visibilitychange',
            handleVisibilityChange
        )
    }
}